// modules
import { handleActions } from 'redux-actions'

// actions
import {
  setEditableTask,
  setDefaultCommentTask,
  setIsAddTaskModalVisible,
  setPatientListTaskModal,
  setCreatedNewTask,
  setHistoryItems,
  setEditableTaskComments
} from 'src/store/modules/tasks'

const initialState = {
  taskList: [],
  editableTask: {},
  editableTaskComments: [],
  defaultCommentTask: {},
  isAddTaskModalVisible: false,
  patientListTaskModal: [],
  createdNewTask: false,
  taskHistoryItems: []
}

export default handleActions(
  {
    [`${setEditableTask}`](state: any, { payload: editableTask }) {
      return {
        ...state,
        editableTask
      }
    },

    [`${setDefaultCommentTask}`](state: any, { payload: defaultCommentTask }) {
      return {
        ...state,
        defaultCommentTask
      }
    },

    [`${setIsAddTaskModalVisible}`](
      state: any,
      { payload: isAddTaskModalVisible }
    ) {
      return {
        ...state,
        isAddTaskModalVisible
      }
    },

    [`${setPatientListTaskModal}`](
      state: any,
      { payload: patientListTaskModal }
    ) {
      return {
        ...state,
        patientListTaskModal
      }
    },

    [`${setCreatedNewTask}`](state: any, { payload: createdNewTask }) {
      return {
        ...state,
        createdNewTask
      }
    },

    [`${setHistoryItems}`](state: any, { payload: taskHistoryItems }) {
      return {
        ...state,
        taskHistoryItems
      }
    },

    [`${setEditableTaskComments}`](
      state: any,
      { payload: editableTaskComments }
    ) {
      return {
        ...state,
        editableTaskComments
      }
    }
  },
  initialState
)
